import { render, staticRenderFns } from "./adminCommentOperationLog.vue?vue&type=template&id=00aa4daa&"
import script from "./adminCommentOperationLog.vue?vue&type=script&lang=js&"
export * from "./adminCommentOperationLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports